import { swap } from 'utils/ArrayUtils';

export interface IColorPaletteState {
  colors: string[];
  selectedIndex: number;
}

export const ColorPaletteDefaultState: IColorPaletteState = {
  colors: [],
  selectedIndex: 0,
};

export enum ColorPaletteAction {
  Add,
  Select,
  Update,
  MoveUp,
  MoveDown,
  Remove,
  SetAll,
}

export function colorPaletteReducer(
  state = ColorPaletteDefaultState,
  action: { type: ColorPaletteAction; value?: any }
): IColorPaletteState {
  let { colors, selectedIndex: selectedColor } = state;
  let currentIndex = state.selectedIndex;

  switch (action.type) {
    case ColorPaletteAction.Add:
      return { ...state, colors: [...colors, action.value] };

    case ColorPaletteAction.Update:
      colors = [...colors];
      colors[currentIndex] = action.value;
      return { ...state, colors };

    case ColorPaletteAction.Select:
      currentIndex = action.value;
      if (currentIndex < 0) {
        console.error('unable to select color', action.value);
        return state;
      }
      return { ...state, selectedIndex: action.value };

    case ColorPaletteAction.MoveUp:
      colors = [...colors];
      currentIndex = Math.max(currentIndex - 1, 0);
      swap(colors, selectedColor, currentIndex);
      return { ...state, colors, selectedIndex: currentIndex };

    case ColorPaletteAction.MoveDown:
      colors = [...colors];
      currentIndex = Math.min(currentIndex + 1, colors.length - 1);
      swap(colors, selectedColor, currentIndex);
      return { ...state, colors, selectedIndex: currentIndex };

    case ColorPaletteAction.Remove:
      colors = [...colors];
      colors.splice(currentIndex, 1);
      selectedColor = Math.min(currentIndex, colors.length - 1);
      return { ...state, colors, selectedIndex: selectedColor };

    case ColorPaletteAction.SetAll:
      return { ...state, colors: action.value, selectedIndex: -1 };

    default:
      return state;
  }
}

export function getSelectedColor(state: IColorPaletteState) {
  return state.colors[state.selectedIndex] || '';
}
